import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f7166246"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "max-w-screen-xl mx-auto" }
const _hoisted_4 = { class: "flex flex-wrap -mx-4" }
const _hoisted_5 = { class: "w-full lg:w-1/4 px-3" }
const _hoisted_6 = { class: "mb-5" }
const _hoisted_7 = {
  key: 0,
  class: "card w-75 shadow-xl"
}
const _hoisted_8 = { class: "card-body items-center text-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Miniature", -1))
const _hoisted_10 = { class: "card-body items-center text-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Icône 3d", -1))
const _hoisted_12 = { class: "w-full lg:w-3/4 px-4" }
const _hoisted_13 = { class: "card w-full shadow-xl" }
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Général", -1))
const _hoisted_16 = { class: "w-full" }
const _hoisted_17 = { class: "mt-2" }
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-3" }, [
  /*#__PURE__*/_createElementVNode("label", { for: "status" }, "Statut")
], -1))
const _hoisted_20 = { class: "card-actions" }
const _hoisted_21 = { key: 0 }

import {onMounted, ref} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import UploadImage from "@/components/forms/UploadImage.vue";
import {ICategory} from "@/models/category/ICategory";
import {IPostCategoryPlayload} from "@/models/category/ICategory";
import {ICategoryForm, IparentValue} from "@/models/category/ICategoryForm";
import {fetchCategory} from "@/_services/category/category";

const submitBtnLabel = 'Créer';

export default /*#__PURE__*/_defineComponent({
  __name: 'AddCategoryForm',
  setup(__props) {

const title = ref<string>("Création de catégorie");
const route = useRoute();
const router = useRouter();
const loading = ref<boolean>(true);
const isAddSubCategory = ref<boolean>(false);
const parentUuidRouteParam = ref<string>("");

onMounted(async () => {
  await getCategoriesParentsChoiceListLabels();
  parentUuidRouteParam.value = route.params.uuid ? route.params.uuid as string : "";
  isAddSubCategory.value = parentUuidRouteParam.value.length ? true : false;
  if (isAddSubCategory.value) {
    title.value = 'Création de sous-catégorie';
    loading.value = false;
    await hydrateFormParentField(parentUuidRouteParam.value);
  }
  loading.value = false;
});

const form = ref<ICategoryForm>({
  name: '',
  slug: '',
  description: '',
  parent: null,
  parentValue: null,
  enabled: true,
  vignette: null,
  icon3d: null,  
});

const hydrateFormParentField = (uuid: string) => {
  fetchCategory(uuid)
    .then((response: ICategory) => {
      const matchingParent = parents.value.find(parent => parent.__original.uuid === response.uuid);
      if (matchingParent) {
        let preSelectedParent: IparentValue = { 
          uuid: matchingParent.__original.uuid,
          lvl: matchingParent.__original.lvl
        };
        form.value.parentValue = preSelectedParent;
      }
    })
    .catch((error) => {
      swal.error("une erreur est survenue lors de la mise à jour du formulaire avec les infos de la catégorie parente.");
    });
}

const parents = ref<Array<any>>([]);
const getCategoriesParentsChoiceListLabels = () => {
  const maxParentDropDownItemsPerPage = 500;

  return new Promise<void>((resolve, reject) => {
    ApiService.get('categories', {
      params: { itemsPerPage: maxParentDropDownItemsPerPage },
      headers: { Accept: "application/json" },
    })
    .then((response) => {
      const data = response.data.data;
      const categories = flattenChildren(data);
      categories[0].label = "Aucune";
      parents.value = categories;
      resolve();
    })
    .catch((error) => {
      reject(error);
    });
  });
}
function getBaseUrl() {
  return window.location.origin;
}
function flattenChildren(arr: any[]): Array<any> {
  const result: Array<any> = [];
  const stack = [...arr];
  while (stack.length > 0) {
    const category = stack.shift();
    if (category.archived || category.lvl === 4) continue;
    result.push({
      value: {
        uuid: category.uuid,
        lvl: category.lvl,
      },
      label: "-".repeat(category.lvl) + category.name,
    });
    /*if (category.children.length > 0) {
      stack.unshift(...category.children);
    }*/
  }
  return [...new Set(result)];
}

const onSubmit = async (formData, formNode) => {
  try {
    const payload: IPostCategoryPlayload = {
      name: formData.name,
      slug: formData.slug,
      description: formData.description,
      enabled: formData.status,
      parent: null !== formData.parentValue ? `/api/categories/${formData.parentValue.uuid}` : null,
      vignette: null !== form.value.vignette ? `/api/images/${form.value.vignette.uuid}` : null, 
        icon3d: null !== form.value.icon3d ? `/api/images/${form.value.icon3d.uuid}` : null
    }
    swal.confirm(
      `Êtes-vous sûr de vouloir créer cette catégorie ?`,
      "Annuler",
      submitBtnLabel
    )
    .then((results) => results.isConfirmed && createCategorie(payload))
  } catch (err: any) {
    swal.error(err.errors[0]);
  }
}

const createCategorie = (data: IPostCategoryPlayload) => {
  ApiService.post('categories', data)
    .then((response) => {
      swal.info("La catégorie "+ response.data.data.name +" a été créée avec succès")
        .then((result) => {
          if (result.isConfirmed) {
            router.push({ name: 'listCategories' });
          }
          form.value.parentValue?.lvl === 0 
            ? router.push({ name: "listCategories" })
            : router.push({
              name: "listCategories",
              params: { uuid: form.value.parentValue?.uuid },
            });
      });
    })
    .catch((error) => {
      swal.error("Une erreur est survenue lors de la création de la catégorie : " + error.response.data.message);
    });
}

const onCancel = () => {
  swal.confirm("Êtes-vous sûr de vouloir annuler ?", "Oui", "Non")
    .then((result) => {
    if (result.isDismissed) {
      router.push({ name: 'listCategories' });
    }
  });
}

const onImageUpload = (image) => {
  form.value.vignette = image;
}

const onImageRemoved = () => {
  form.value.vignette = null;
}

const onImageUpload3d = (image) => {
    form.value.icon3d = image;
}

const onImageRemoved3d = () => {
    form.value.icon3d = null;
}

const onImageUploadError = (errorMsg: string) => {
  swal.error(errorMsg);
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(title.value), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (!form.value.parentValue || form.value.parentValue?.lvl === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(UploadImage, {
                      "image-preview-url": form.value.vignette ? form.value.vignette.url : getBaseUrl() + '/media/blank2.png',
                      onImageRemoved: onImageRemoved,
                      onImageUploaded: onImageUpload,
                      onError: onImageUploadError
                    }, null, 8, ["image-preview-url"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(UploadImage, {
                      "image-preview-url": form.value.icon3d ? form.value.icon3d.url : getBaseUrl() + '/media/blank2.png',
                      onImageRemoved: onImageRemoved3d,
                      onImageUploaded: onImageUpload3d,
                      onError: onImageUploadError,
                      "accepted-extensions": ['.png']
                    }, null, 8, ["image-preview-url", "accepted-extensions"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_FormKit, {
                  type: "form",
                  actions: false,
                  model: form.value,
                  onSubmit: onSubmit,
                  "outer-class": "w-full",
                  "incomplete-message": "Veuillez remplir tous les champs correctement"
                }, {
                  default: _withCtx(({ state: { valid } }) => [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("div", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass({
                        'badge': true,
                        'badge-error': !form.value.enabled,
                        'badge-success': form.value.enabled,
                        'badge-circle': true
                      })
                          }, null, 2)
                        ])
                      ]),
                      _createVNode(_component_FormKit, {
                        type: "select",
                        name: "status",
                        modelValue: form.value.enabled,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.enabled) = $event)),
                        help: "Faire apparaitre ou non la catégorie dans le catalogue",
                        options: [
                      { label: 'Activé', value: true },
                      { label: 'Désactivé', value: false },
                    ]
                      }, null, 8, ["modelValue"])
                    ]),
                    _createVNode(_component_FormKit, {
                      type: "autocomplete",
                      name: "parentValue",
                      modelValue: form.value.parentValue,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.parentValue) = $event)),
                      label: "Parent *",
                      placeholder: "Choisissez une catégorie parente",
                      validation: "required",
                      options: parents.value,
                      "validation-messages": {
                    required: 'La catégorie parente est obligatoire',
                  }
                    }, null, 8, ["modelValue", "options"]),
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "slug",
                      modelValue: form.value.slug,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.slug) = $event)),
                      label: "Slug *",
                      validation: "required | matches:/^[^\\s][a-zA-Z0-9-_/%]*$/",
                      "validation-messages": {
                    required: 'Le slug est obligatoire',
                    matches: 'Le slug ne doit contenir que des lettres, des chiffres, des tirets et des slashs et ne doit pas commencer par un espace',
                  }
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "name",
                      label: "Nom *",
                      modelValue: form.value.name,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.name) = $event)),
                      validation: "required | length:1,30",
                      "validation-messages": {
                    required: 'Le nom est obligatoire',
                    length: 'Le nom ne doit pas dépasser 30 caractères',
                  }
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_FormKit, {
                      type: "textarea",
                      name: "description",
                      modelValue: form.value.description,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.description) = $event)),
                      label: "Description",
                      validation: "length:0,255",
                      "validation-messages": {
                    length: 'La description ne doit pas dépasser 255 caractères',
                  }
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_20, [
                      (loading.value === false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createVNode(_component_FormKit, {
                              type: "submit",
                              label: submitBtnLabel,
                              disabled: !valid,
                              class: _normalizeClass({ 'btn-primary': true, 'btn-block': true })
                            }, null, 8, ["disabled"])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_FormKit, {
                        type: "button",
                        label: "Annuler",
                        onClick: onCancel,
                        class: _normalizeClass({ 'btn-secondary': true, 'btn-block': true })
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["model"])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})